import { typeof as _typeof, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { updateResource, readEndpoint } from 'redux-json-api';
import { displayError, clearMessages, displaySuccessMessage, capitalizeMessage } from './messagesActions.js';
import { setActivePage, readLocal, loadEntities, clearApiState } from './coreApiActions.js';
import { i18n } from '../i18n/translate.js';
import { loadExternalData } from '../utils/ApiUtil.js';
import { buildUrl } from '../json-api/JsonApiUtils.js';
import cloneDeep from 'lodash/cloneDeep.js';
var readEntity = function readEntity(entity) {
  var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sorts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var query = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var clearState = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  var entityAlias = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
  var skipJSONExtension = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  if (_typeof(entity) === 'object') {
    return readEntityFromObject(entity);
  } else {
    return readEntityFromParams(entity, includes, filters, sorts, page, query, clearState, entityAlias, skipJSONExtension);
  }
};
var readEntityFromParams = function readEntityFromParams(entity, includes, filters, sorts, page, query, clearState, entityAlias, skipJSONExtension) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var extension, url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            extension = skipJSONExtension ? '' : '.json';
            url = buildUrl("".concat(entity).concat(extension), {
              includes: includes,
              filters: filters,
              sorts: sorts,
              page: page,
              query: query
            });
            dispatchActivePage(dispatch, page);
            _context.next = 5;
            return readEntityFromUrl(dispatch, getState, entity, url, null, clearState, '', '', entityAlias);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var readEntityFromObject = function readEntityFromObject(_ref2) {
  var entity = _ref2.entity,
    includes = _ref2.includes,
    filters = _ref2.filters,
    sorts = _ref2.sorts,
    page = _ref2.page,
    query = _ref2.query,
    fields = _ref2.fields,
    token = _ref2.token,
    _ref2$clearState = _ref2.clearState,
    clearState = _ref2$clearState === void 0 ? true : _ref2$clearState,
    entityAlias = _ref2.entityAlias,
    _ref2$basePath = _ref2.basePath,
    basePath = _ref2$basePath === void 0 ? '' : _ref2$basePath,
    _ref2$host = _ref2.host,
    host = _ref2$host === void 0 ? '' : _ref2$host,
    _ref2$skipJSONExtensi = _ref2.skipJSONExtension,
    skipJSONExtension = _ref2$skipJSONExtensi === void 0 ? false : _ref2$skipJSONExtensi;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var _getState, _getState$api, activeFilters, activePage, activeSearch, activeSort, extension, url;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState = getState(), _getState$api = _getState.api, activeFilters = _getState$api.activeFilters, activePage = _getState$api.activePage, activeSearch = _getState$api.activeSearch, activeSort = _getState$api.activeSort;
            filters = filters || activeFilters;
            sorts = sorts || activeSort;
            page = page || activePage;
            query = query || activeSearch;
            extension = skipJSONExtension ? '' : '.json';
            url = buildUrl("".concat(entity).concat(extension), {
              includes: includes,
              filters: filters,
              sorts: sorts,
              page: page,
              query: query,
              fields: fields
            });
            dispatchActivePage(dispatch, page);
            _context2.next = 10;
            return readEntityFromUrl(dispatch, getState, entity, url, token, clearState, basePath, host, entityAlias);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var dispatchActivePage = function dispatchActivePage(dispatch, page) {
  var number;
  if (page) {
    if (Number.isInteger(page)) {
      number = page;
    } else {
      number = page.number;
    }
  }
  if (number) {
    dispatch(setActivePage({
      number: number
    }));
  }
};
var readEntityFromUrl = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState, entity, url, token, clearState) {
    var basePath,
      host,
      entityAlias,
      data,
      read,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          basePath = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : '';
          host = _args3.length > 7 && _args3[7] !== undefined ? _args3[7] : '';
          entityAlias = _args3.length > 8 && _args3[8] !== undefined ? _args3[8] : undefined;
          dispatch(loadEntities(entityAlias || entity, url));
          if (!token) {
            _context3.next = 12;
            break;
          }
          _context3.next = 7;
          return loadExternalData("".concat(host).concat(basePath).concat(url), token, false);
        case 7:
          data = _context3.sent;
          data.endpoint = url;
          dispatch(readLocal(data));
          _context3.next = 25;
          break;
        case 12:
          _context3.prev = 12;
          read = readEndpoint(url);
          if (!clearState) {
            _context3.next = 19;
            break;
          }
          _context3.next = 17;
          return read(function (params) {
            if (params.type === 'API_READ') {
              dispatch(clearApiState(entityAlias || entity));
            }

            // tag objects directly from the request to differentiate them from included entities,
            // to account for scenarios where an object has a child relationship with the same entity type
            if (params.payload && _typeof(params.payload) === 'object') {
              if (params.payload.data) {
                params.payload.data.forEach(function (obj) {
                  if (entityAlias) {
                    obj.type = entityAlias;
                  }
                  if (obj.meta) {
                    obj.meta.included = false;
                  } else {
                    obj.meta = {
                      included: false
                    };
                  }
                });
              }
              if (params.payload.included) {
                params.payload.included.forEach(function (obj) {
                  if (obj.meta) {
                    obj.meta.included = true;
                  } else {
                    obj.meta = {
                      included: true
                    };
                  }
                });
              }
            }
            dispatch(params);
          }, function () {
            var endpointOverride = {};
            if (basePath) {
              endpointOverride.path = basePath;
            }
            if (host) {
              endpointOverride.host = host;
            }
            var state = cloneDeep(getState());
            state.api.endpoint = _objectSpread2(_objectSpread2({}, state.api.endpoint), endpointOverride);
            return state;
          });
        case 17:
          _context3.next = 20;
          break;
        case 19:
          dispatch(read);
        case 20:
          _context3.next = 25;
          break;
        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](12);
          dispatch(displayError(_context3.t0));
        case 25:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[12, 22]]);
  }));
  return function readEntityFromUrl(_x5, _x6, _x7, _x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var updateEntityAndRefreshAll = function updateEntityAndRefreshAll(entity, includes, filters, sorts, afterSave, successMessage) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var update, entityTypeForDisplay, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            update = updateResource(entity.unwrap());
            entityTypeForDisplay = capitalizeMessage(entity.unwrap().type);
            _context4.prev = 2;
            _context4.next = 5;
            return update(dispatch, getState);
          case 5:
            response = _context4.sent;
            dispatch(clearMessages());
            //added timeout for elasticsearch to finish reindexing (which takes about a second)
            //in order to return updated list results
            if (successMessage !== false) {
              setTimeout(function () {
                dispatch(readEntity(entity.unwrap().type, includes, filters, sorts));
                dispatch(displaySuccessMessage(successMessage || i18n.t('%s updated successfully!', {
                  postProcess: 'sprintf',
                  sprintf: [entityTypeForDisplay]
                })));
              }, 1000);
            }
            if (typeof afterSave === 'function') {
              afterSave(dispatch, getState);
            }
            return _context4.abrupt("return", response);
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](2);
            dispatch(displayError(_context4.t0));
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 12]]);
    }));
    return function (_x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var readExternalEntity = function readExternalEntity(host, token, entity, includes, filters, page) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch) {
      var url, data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            url = buildUrl("".concat(host).concat(entity, ".json"), {
              includes: includes,
              filters: filters,
              page: page
            });
            dispatch(loadEntities(entity, url));
            _context5.prev = 2;
            _context5.next = 5;
            return loadExternalData(url, token, false);
          case 5:
            data = _context5.sent;
            //set endpoint so loadingEntities clear correctly
            data.endpoint = url;
            dispatch(readLocal(data));
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            dispatch(displayError(_context5.t0));
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 10]]);
    }));
    return function (_x13) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export { readEntity, readExternalEntity, updateEntityAndRefreshAll };